import { get } from 'lodash';

export const newCustomLayers = (state = {}, action) => {
  switch (action.type) {
    case 'REPLACE_NEW_CUSTOM_LAYER': {
      return {
        ...state,
        [action.payload.key]: action.payload.layer,
      };
    }
    case 'CREATE_NEW_CUSTOM_LAYERS': {
      return {
        ...state,
        ...action.payload.layers.reduce((acc, layer) => {
          acc[layer.key] = {
            ...(state[layer.key] || {}),
            ...layer,
          };
          return acc;
        }, {}),
      };
    }
    case 'UPDATE_CUSTOM_LAYER_NAME': {
      const newState = { ...state };
      const { key, label } = action.payload;
      newState[key].label = label;
      return newState;
    }
    case 'UPDATE_CUSTOM_LAYER_SOURCE': {
      const newState = { ...state };
      const {
 key, source, dataKey, forceDots,
} = action.payload;
      newState[key] = { ...newState[key] };
      newState[key].source = source;
      newState[key].forceDots = forceDots;
      newState[key].dataKey = dataKey;
      return newState;
    }
    case 'UPDATE_CUSTOM_LAYER_FILTER': {
      const id = action.payload.key;
      const { key, value, operator = 'eq' } = action.payload.filter;

      if (value === 'EMPTY') {
        const newState = { ...state };
        const newFilters = { ...newState[id].filters };
        delete newFilters[key];
        newState[id].filters = newFilters;

        return newState;
      }
      const prev = { ...get(state[id], `filters.${key}`, {}) };

      let filters;
      if (!`${value}`.length) {
        delete prev[operator];
        filters = {
          ...get(state[id], 'filters', {}),
          [key]: {
            ...prev,
          },
        };
      } else {
        filters = {
          ...get(state[id], 'filters', {}),
          [key]: {
            ...prev,
            [operator]: value,
          },
        };
      }

      return {
        ...state,
        [id]: {
          ...state[id],
          filters,
        },
      };
    }
    case 'CLEAR_CUSTOM_LAYER_FILTERS': {
      const { key } = action.payload;
      const newState = { ...state };
      newState[key].filters = {};
      return newState;
    }
    case 'CLEAR_NEW_CUSTOM_LAYERS': {
      return {};
    }
    case 'REMOVE_NEW_CUSTOM_LAYER': {
      const newState = { ...state };
      delete newState[action.payload.key];
      return newState;
    }
    case 'UPDATE_CUSTOM_LAYER_STYLES': {
      const {
 key, type, color, opacity,
} = action.payload;
      const style = {
        type,
        opacity,
        paint: {
          [`${type}-color`]: color,
        },
      };

      if (type === 'line') {
        style.paint['line-width'] = 1;
      }

      const newState = {
        ...state,
        [key]: {
          ...state[key],
          style,
        },
      };

      return newState;
    }
    case 'REMOVE_USERS_FROM_LAYER': {
      const newState = { ...state };
      const users = newState[action.payload.layerId].users || [];
      newState[action.payload.layerId].users = users.filter(
        ({ id }) => !action.payload.userIds.includes(id),
      );
      return newState;
    }
    case 'ADD_USERS_TO_LAYER': {
      const newState = { ...state };
      const users = [
        ...action.payload.users,
        ...(newState[action.payload.layerId].users || []),
      ];
      newState[action.payload.layerId].users = users;
      return newState;
    }
    default:
      return state;
  }
};
